const footerColumns = [
  {
    title: "Our Pillars",
    links: [
      { label: "Product Sourcing", href: "#services" },
      { label: "Wholesale Supply", href: "#services" },
      { label: "Inventory Solutions", href: "#overstock" },
      { label: "How It Works", href: "#how-it-works" },
      { label: "Why LTF Sourcing", href: "#about" },
    ],
  },
  {
    title: "Inventory Solutions",
    links: [
      { label: "Browse Inventory", href: "#overstock" },
      { label: "Request a Quote", href: "#overstock" },
      { label: "List Your Inventory", href: "#overstock" },
      { label: "Bulk Buyer Network", href: "#overstock" },
      { label: "Overstock Deals", href: "#overstock" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About LTF Sourcing", href: "#about" },
      { label: "Testimonials", href: "#testimonials" },
      { label: "FAQ", href: "#faq" },
      { label: "Contact Us", href: "#contact" },
      { label: "Get a Quote", href: "#contact" },
    ],
  },
];

const pillarBadges = [
  { icon: "ri-search-eye-line", label: "Product Sourcing" },
  { icon: "ri-store-3-line", label: "Wholesale Supply" },
  { icon: "ri-archive-drawer-line", label: "Inventory Solutions" },
];

export default function Footer() {
  const handleNavClick = (href: string) => {
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#D9E2EC] border-t border-[#c4d0de]">

      {/* Upper */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">

        {/* Brand — spans 2 cols */}
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-8 h-8 rounded-lg bg-[#C9A227] flex items-center justify-center">
              <i className="ri-links-line text-white text-base"></i>
            </div>
            <span className="font-bold text-lg text-[#222831]">LTF Sourcing</span>
          </div>

          <p className="text-sm text-[#3A506B] leading-relaxed max-w-xs">
            Your end-to-end procurement partner — built around three pillars:
            Product Sourcing, Wholesale Supply, and Inventory Solutions.
            Serving 75+ businesses across 8+ countries and growing.
          </p>

          {/* Pillar badges */}
          <div className="flex flex-col gap-2 mt-5">
            {pillarBadges.map((b) => (
              <div key={b.label} className="flex items-center gap-2">
                <i className={`${b.icon} text-[#C9A227] text-sm`}></i>
                <span className="text-xs font-semibold text-[#3A506B]">{b.label}</span>
              </div>
            ))}
          </div>

          {/* Socials */}
          {/* Social media icons removed */}
        </div>

        {/* Link Columns */}
        {footerColumns.map((col) => (
          <div key={col.title}>
            <h4 className="text-xs font-bold text-[#222831] mb-4 uppercase tracking-widest">
              {col.title}
            </h4>
            <ul className="flex flex-col gap-2.5">
              {col.links.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                    className="text-sm text-[#3A506B] hover:text-[#C9A227] transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Lower */}
      <div className="border-t border-[#c4d0de]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#3A506B]">
            &copy; {new Date().getFullYear()} LTF Sourcing. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" rel="nofollow" className="text-xs text-[#3A506B] hover:text-[#C9A227] transition-colors cursor-pointer whitespace-nowrap">
              Privacy Policy
            </a>
            <a href="#" rel="nofollow" className="text-xs text-[#3A506B] hover:text-[#C9A227] transition-colors cursor-pointer whitespace-nowrap">
              Terms of Service
            </a>
            <a href="#" rel="nofollow" className="text-xs text-[#3A506B] hover:text-[#C9A227] transition-colors cursor-pointer whitespace-nowrap">
              Cookie Policy
            </a>
          </div>
        </div>
      </div>

    </footer>
  );
}
